export const BR = '\n';
export const I = '  ';
export const II = '    ';
export const III = '      ';
